var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObligationToYieldOncomTrafficCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EA0029;}\r\n\t.st1{fill:#FFCD00;}\r\n\t.st2{fill:#1D1D1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,8) scale(0.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 40,
    cy: 40,
    r: 34
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9728 -0.2316 0.2316 0.9728 -8.1763 10.3512)",
    className: "st1",
    cx: 40,
    cy: 40,
    rx: 26.1,
    ry: 26.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "29.5,23.7 26.4,23.7 26.4,45.6 19,45.6 29.5,56.1 40,45.6 32.6,45.6 32.6,23.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "50.5,56.1 53.6,56.1 53.6,34.2 61,34.2 50.5,23.7 40,34.2 47.4,34.2 47.4,56.1 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObligationToYieldOncomTrafficCanvas);
export default __webpack_public_path__ + "static/media/obligation-to-yield-oncom-traffic-canvas.a66eac19ab9185afd8d35c2a39538ad7.svg";
export { ForwardRef as ReactComponent };